<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu
            offset-y
            v-if="
              user.roleName == 'SALE_MANAGER' ||
              user.roleName == 'GENERAL_MANAGER'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAll('printAllWholeSale')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllWholeSale()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="invoiceNo"
                label="Invoice No"
                type="text"
                v-model="queryParams.invoiceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="Order No"
                label="Order No"
                type="text"
                v-model="queryParams.ordNo"
              ></v-text-field>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.roleName == 'ADMIN' ||
                user.roleName == 'FINANCE_MANAGER' ||
                user.roleName == 'BRANCH_ADMIN'
              "
            >
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="name"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="orderList"
                label="Order"
                v-model="queryParams.orderType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.saleTeamIds"
                :items="saleTeamList"
                label="Sale Team"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
          </v-card-title>
          <v-card-text class="font-weight-bold">
            <div>
              <span>Total Net Amount:</span>
              <v-chip>
                <span>{{ totalNetAmount | decFormat(6) }}</span>
              </v-chip>

              <span>Total Sale Amount:</span>
              <v-chip>
                <span>{{ totalSaleAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Tax Amount:</span>
              <v-chip>
                <span>{{ totalTaxAmount | decFormat(6) }}</span>
              </v-chip>

              <span>Total Discount Amount:</span>
              <v-chip>
                <span>{{ totalDiscountAmount | decFormat(6) }}</span>
              </v-chip>

              <span>Total Expense Amount:</span>
              <v-chip>
                <span>{{ totalExpenseAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Promotion Amount:</span>
              <v-chip>
                <span>{{ totalPromotionAmount | decFormat(6) }}</span>
              </v-chip>
              <span>Total Return Amount:</span>
              <v-chip>
                <span>{{ totalReturnAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="wholeSaleList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <!-- minus 1 from print count to remove print from sale -->
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      flat
                      icon
                      :color="
                        props.item.salePrintCount > 1
                          ? 'success'
                          : 'blue lighten-2'
                      "
                      @click="print(props.item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>print</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    props.item.salePrintCount > 0
                      ? props.item.salePrintCount - 1
                      : props.item.salePrintCount
                  }}</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.status }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.ordNo }}</td>
              <td>{{ props.item.customerName }}</td>
              <td>{{ props.item.customer.code }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.saleTeamName }}</td>
              <td>{{ props.item.currencyCode }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{ props.item.netAmount | decFormat(6) }}
              </td>
              <td>
                {{ props.item.returnAmount | decFormat(6) }}
              </td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- customer dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerList"
              :headers="customerHeaders"
              :items="activeCustomerList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="customerTotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="customerPagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedCustomerList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomer">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <summary report> -->
    <div
      id="printAllWholeSale"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Sale Summary</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Total Amount: {{ totalNetAmount | decFormat(6) }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Total Tax Amount: {{ totalTaxAmount | decFormat(6) }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Total Sale Amount: {{ totalSaleAmount | decFormat(6) }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Total Discount Amount:
          {{ totalDiscountAmount | decFormat(6) }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Total Expense Amount:
          {{ totalExpenseAmount | decFormat(6) }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Total Promotion Amount:
          {{ totalPromotionAmount | decFormat(6) }}
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 0px">
          Total Return Amount:
          {{ totalReturnAmount | decFormat(6) }}
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Issue Date</th>
              <th style="text-align: left">Issue No</th>
              <th style="text-align: left">Invoice No</th>
              <th style="text-align: left">Customer Name</th>
              <th style="text-align: left">Customer Code</th>
              <th style="text-align: left">Shop</th>
              <th style="text-align: left">Currency</th>
              <th style="text-align: left">Status</th>
              <th style="text-align: left">Description</th>
              <th style="text-align: left">Net Amount</th>
              <th style="text-align: left">Sale Return Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allWholeSaleList" :key="index">
              <td style="text-align: left">
                {{ item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td style="text-align: left">{{ item.issueNo }}</td>
              <td style="text-align: left">{{ item.invoiceNo }}</td>
              <td style="text-align: left">{{ item.customer.name }}</td>
              <td style="text-align: left">{{ item.customer.code }}</td>
              <td style="text-align: left">{{ item.shopName }}</td>
              <td style="text-align: left">{{ item.currencyCode }}</td>
              <td style="text-align: left">{{ item.status }}</td>
              <td style="text-align: left">{{ item.description }}</td>
              <td style="text-align: left">
                {{ item.netAmount | decFormat(6) }}
              </td>
              <td style="text-align: left">
                {{ item.returnAmount | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { wholeSaleService } from "../../services/whole-sale-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { saleTeamService } from "../../services/sale-team-service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { customerService } from "../../services/customer-service";
export default {
  name: "WholeSaleList",
  components: { Loading },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    printAllLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Sale",
        disabled: true,
      },
      {
        text: "Sale",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "IssueDate", align: "left", value: "issueDate" },
      { text: "Issue No.", value: "issueNo" },
      { text: "Invoice No.", value: "invoiceNo" },
      { text: "Order No.", value: "invoiceNo", sortable: false },
      { text: "Customer Name", value: "customer.name" },
      { text: "Customer Code", value: "customer.code" },
      { text: "Shop", value: "shop.name" },
      { text: "Sale Team", sortable: false },
      { text: "Currency", value: "currencyCode" },
      { text: "Description", value: "description" },
      { text: "Net Amount", value: "netAmount" },
      { text: "Sale Return Amount", value: "totalReturnAmount" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    customerHeaders: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    activeCustomerList: [],
    selectedCustomerList: [],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0,
    },
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    customerTotalRows: 0,
    showCustomerListDialog: false,
    wholeSaleList: [],
    allWholeSaleList: [],
    shopList: [],
    saleTeamList: [],
    totalRows: 0,
    totalNetAmount: 0,
    totalTaxAmount: 0,
    totalSaleAmount: 0,
    totalDiscountAmount: 0,
    totalExpenseAmount: 0,
    totalPromotionAmount: 0,
    totalReturnAmount: 0,
    decimalFormat: "",
    statusList: [
      { label: "All", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    orderList: [
      { label: "All", value: "" },
      { label: "WITH ORDER", value: "WITHORDER" },
      { label: "WITHOUT ORDER", value: "WITHOUTORDER" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerCode: "",
      customerName: "",
      issueNo: "",
      invoiceNo: "",
      ordNo: "",
      status: "",
      shopId: "",
      orderType: "",
      updateUserId: "",
      description: "",
      saleTeamIds: [],
      customerIds: [],
    },
    customerQueryParams: {
      name: "",
      code: "",
      email: "",
    },
    isLoading: false,
    fullPage: true,
  }),
  watch: {
    pagination: {
      handler() {
        this.getWholeSaleList();
      },
      deep: true,
    },
    customerPagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
  },

  created() {
    this.getActiveSaleTeams();
    this.decimalFormat = commonService.formatdecimal();
    let user = JSON.parse(localStorage.getItem("user"));
    if (
      user.role.roleName == "ADMIN" ||
      user.role.roleName == "FINANCE_MANAGER" ||
      user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.getAllShop();
    }
    if (
      user.role.roleName == "GENERAL_MANAGER" ||
      user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.shopId = user.shop.id;
    }
    if (user.role.roleName == "SALE_MANAGER") {
      this.queryParams.updateUserId = user.id;
    }
    this.getWholeSaleSummary();
    //for deep linking
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.invoiceNo) {
      this.queryParams.invoiceNo = this.$route.query.invoiceNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.customerCode) {
      this.queryParams.customerCode = this.$route.query.customerCode;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.ordNo) {
      this.queryParams.ordNo = this.$route.query.ordNo;
    }
    if (this.$route.query.orderType) {
      this.queryParams.orderType = this.$route.query.orderType;
    }
    if (this.$route.query.customerIds) {
      if(Array.isArray(this.$route.query.customerIds)) {
        this.queryParams.customerIds = this.$route.query.customerIds.map(Number);
      } else {
        this.queryParams.customerIds = [Number(this.$route.query.customerIds)];
      }
      this.getActiveCustomer().then(()=>{
        this.selectedCustomerList = this.activeCustomerList.filter(customer => this.queryParams.customerIds.includes(customer.id));
      });
    }
    if (this.$route.query.saleTeamIds) {
      if(Array.isArray(this.$route.query.saleTeamIds)){
        this.queryParams.saleTeamIds = this.$route.query.saleTeamIds.map(Number);
      } else {
        this.queryParams.saleTeamIds = [Number(this.$route.query.saleTeamIds)];
      }
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "whole-sales", query: this.queryParams });
      this.getWholeSaleList();
      this.getWholeSaleSummary();
    },
    getWholeSaleList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      wholeSaleService
        .getWholeSaleList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.wholeSaleList = res.data.wholeSaleHeaderList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getWholeSaleSummary() {
      this.showListLoading = true;
      wholeSaleService
        .getWholeSaleSummary(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.totalNetAmount = res.data.totalAmount;
            this.totalTaxAmount = res.data.totalTaxAmount;
            this.totalSaleAmount = res.data.totalSaleAmount;
            this.totalDiscountAmount = res.data.totalDiscountAmount;
            this.totalExpenseAmount = res.data.totalExpenseAmount;
            this.totalPromotionAmount = res.data.totalPromotionAmount;
            this.totalReturnAmount = res.data.totalReturnAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllWholeSale() {
      this.printAllLoading = true;
      wholeSaleService
        .exportWholeSaleExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printAllLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/whole-sale/new");
    },
    onEdit(wholeSale) {
      // go to details page
      this.$router.push("/whole-sale/" + wholeSale.id);
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getActiveSaleTeams() {
      saleTeamService
        .getSaleTeamsByStatus("ACTIVE")
        .then((res) => {
          this.saleTeamList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    print(item) {
      this.isLoading = true;
      wholeSaleService
        .printInvoiceById(item.id)
        .then((res) => {
          var blob = res;
          wholeSaleService.showWindowDialog(
            blob,
            "WholeSaleInvoice-" + item.id
          );
          // to update on UI without api call
          item.salePrintCount += 1;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    printAll(divName) {
      this.printAllLoading = true;
      wholeSaleService
        .getAllWholeSaleList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.totalNetAmount = 0.0;
            this.allWholeSaleList = res.data.wholeSaleHeaderList;
            for (let temp of this.allWholeSaleList) {
              this.totalNetAmount += temp.netAmount;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllLoading = false;
        });
    },
    showCustomers() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.email = "";
      this.selectedCustomerList = [];
      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.pagination.page;
      this.customerQueryParams.size = this.pagination.rowsPerPage;
      this.getActiveCustomer();
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.activeCustomerList.slice();
      }
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
  },
};
</script>
